var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9272 13.202L8.48118 2.26C8.42915 2.17989 8.35786 2.11411 8.27383 2.06869C8.18979 2.02326 8.0957 1.99965 8.00018 2C7.90466 1.99965 7.81057 2.02326 7.72654 2.06869C7.6425 2.11411 7.57121 2.17989 7.51918 2.26L1.07318 13.202C1.02509 13.2834 0.999968 13.3764 1.0005 13.4709C1.00102 13.5655 1.02718 13.6581 1.07618 13.739C1.17618 13.904 1.35818 14.004 1.55418 13.999H14.4462C14.5417 14.0013 14.6361 13.9786 14.72 13.9329C14.8038 13.8873 14.8743 13.8204 14.9242 13.739C15.0242 13.574 15.0252 13.369 14.9272 13.202ZM8.87518 12.285H7.12518V10.57H8.87518V12.285ZM8.87518 9.712H7.12518V5.425H8.87518V9.712Z",
    fill: "#FF7300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b5a8c331b32415088c658d18e07c5f6c.svg";
export { ForwardRef as ReactComponent };